import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { ReactElement, useState } from "react";

interface CollapseProps {
    title: string
    content: ReactElement
}

export default function Collaps({title, content}: CollapseProps) {

    const [isOpen, setIsOpen] = useState<boolean>(true);
    

    return(
         <div className="bg-white shadow-lg rounded-lg">
            <div className="flex justify-between items-center p-4" >
                <p>{ title }</p>
                <button onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? <ChevronUpIcon className="w-5 h-5" /> : <ChevronDownIcon className="w-5 h-5" />}
                </button>
            </div>

            { isOpen && <>{ content }</> }
         </div>
    )
}